import React from 'react';
import '../less';
import LandingGold from '../views/landing/gold.c';
import LandingKUN from '../views/landing/kun.c';
import LandingKDV from '../views/landing/kdv-new.c';
import LandingGC from '../../GreenCard';
import List from '../views/list.c';
import OrderGold from '../views/order/gold.c';
import Yellow from '../yellow/views/yellow.c';
import OrderKUN from '../views/order/kun.c';
import OrderKDV from '../views/order/kdv.c';
import LandingPlatinum from '../platinum/views/platinum.c';
import LandingUT from '../../UkrainiansTogether';
import GoogleTagManager from '../../../services/GoogleTagManager';
import ProjectSupport from '../ProjectSupport';
import ATB from '../../ATB';
import Profit from '../profit/views/main.c';
import eVidnovlennia from '../eVidnovlennia';
import childrens from '../childrens';
import cashbackUA from '../cashbackUA';
import bolt from "../bolt";
import diiaC from "../diia";

const list = {
    gold: {
        order: OrderGold,
        landing: LandingGold,
    },
    kdv: {
        order: OrderKDV,
        landing: LandingKDV,
    },
    kun: {
        order: OrderKUN,
        landing: LandingKUN,
    },
    green: {
        landing: LandingGC,
    },
    yellow: {
        landing: Yellow,
    },
    premium: {
        landing: LandingPlatinum,
    },
    ukrainians_together: {
        landing: LandingUT,
    },
    'project-support': {
        landing: ProjectSupport,
    },
    'atb': {
       landing: ATB,
    },
    vygoda: {
        landing: Profit
    },
    eVidnovlennia: {
        landing: eVidnovlennia
    },
    'kid-card': {
        landing: childrens
    },
    cashback_ua: {
        landing: cashbackUA
    },
    diia: {
        landing: diiaC
    },
    bolt: {
        landing: bolt
    },
};

export default function template() {
    let Component;
    const { match = {} } = this.props,
        type = match.params && match.params.type,
        action = (match.params && match.params.action) || 'landing';
    if (type) {
        Component = list[type][action];
    } else {
        Component = List;
    }

    return (
        <div className="module-cards">
            {/* <GoogleTagManager gtmId='GTM-PJL9JV5' scriptId='scriptId1' dataLayerName='dataLayer' additionalEvents={event} previewVariables='' />*/}
            <Component {...this.props} utmParams={this.utmParams} />
        </div>
    );
}
